import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon, XIcon } from 'lucide-react';
import { Button } from '../../ui/Button';
import { UniversityMark } from '../UniversityMark';
import { useDiscover } from '../../../contexts/DiscoverContext';

/**
 * Design B's comparison tray: a floating bar that stays with you while you keep
 * scanning the grid. Same state as Design A's in-flow panel — an institution
 * added in one composition is still in the tray in the other.
 */
export function CompareBarB() {
  const {
    compared,
    removeCompare,
    clearCompare,
    setCompareOpen
  } = useDiscover();
  const [collapsed, setCollapsed] = useState(false);
  if (compared.length === 0) return null;
  return <div className="pointer-events-none fixed inset-x-0 bottom-0 z-30 px-3 pb-3 lg:pl-[260px]" data-id="element-1338" data-mp="njw07k8y5hj3">
      <div className="pointer-events-auto mx-auto max-w-5xl rounded-card border border-line bg-surface px-3 py-2.5 shadow-[0_-6px_36px_rgba(15,23,42,0.16)] sm:px-4" data-id="element-1339" data-mp="rl943oshband">
        <div className="flex flex-wrap items-center gap-3" data-id="element-1340" data-mp="whzogobbgsel">
          <p className="text-caption font-semibold uppercase tracking-wide text-ink-subtle" data-id="element-1341" data-mp="3hkrmwb69el5p">
            Compare ({compared.length})
          </p>
          <button type="button" onClick={clearCompare} className="text-body-sm text-ink-muted underline-offset-4 hover:text-ink hover:underline" data-id="element-1342" data-mp="3dkhe6qr31gn5">
            Clear
          </button>

          {!collapsed && <ul className="flex min-w-0 flex-wrap items-center gap-2" data-id="element-1343" data-mp="5105ph6yfqth">
              {compared.map(university => <li key={university.id} className="flex items-center gap-2" data-id="element-1344" data-mp="405vo0p7kat">
                  <UniversityMark university={university} size="sm" data-id="element-1345" data-mp="3rgl3c5n3mysr" />
                  <span className="min-w-0" data-id="element-1346" data-mp="3mjb45y9wr8rq">
                    <span className="block max-w-[11rem] truncate text-body-sm font-medium text-ink" data-id="element-1347" data-mp="3mijbowblxr5o">
                      {university.name}
                    </span>
                    <span className="block text-caption text-ink-muted" data-id="element-1348" data-mp="j11erjxdi4k1">
                      {university.city}, {university.country}
                    </span>
                  </span>
                  <button type="button" onClick={() => removeCompare(university.id)} aria-label={`Remove ${university.name} from the comparison`} className="flex min-h-touch min-w-touch items-center justify-center rounded-lg text-ink-subtle transition-colors duration-150 ease-out hover:text-ink" data-id="element-1349" data-mp="2hbrsrq1m8mbk">
                    <XIcon aria-hidden className="h-4 w-4" data-id="element-1350" data-mp="1ylagew13c3cd" />
                  </button>
                </li>)}
            </ul>}

          <div className="ml-auto flex items-center gap-2" data-id="element-1351" data-mp="1knc4dxa8sj01">
            <Button variant="primary" onClick={() => setCompareOpen(true)} disabled={compared.length < 2} data-id="element-1352" data-mp="1pldjk74jry68">
              Compare now
            </Button>
            <button type="button" onClick={() => setCollapsed(current => !current)} aria-expanded={!collapsed} aria-label={collapsed ? 'Show selected universities' : 'Hide selected universities'} className="flex min-h-touch min-w-touch items-center justify-center rounded-lg border border-line text-ink-muted transition-colors duration-150 ease-out hover:text-ink" data-id="element-1353" data-mp="3jx25wud3z30n">
              {collapsed ? <ChevronUpIcon aria-hidden className="h-5 w-5" data-id="element-1354" data-mp="gmm4w1r81qlr" /> : <ChevronDownIcon aria-hidden className="h-5 w-5" data-id="element-1355" data-mp="bou6cow2n68l" />}
            </button>
          </div>
        </div>
      </div>
    </div>;
}